import React from 'react';
import { BULLETED_LIST_MENU_ITEM, INDENT_MENU_ITEM, LISTS_INDENTATION_GROUP, LISTS_INDENTATION_HERO_BUTTON, LISTS_INDENTATION_MENU, LISTS_INDENTATION_MENU_SECTION, NUMBERED_LIST_MENU_ITEM, OUTDENT_MENU_ITEM, TEXT_SECTION, TEXT_SECTION_RANK, LISTS_INDENTATION_GROUP_RANK, LISTS_INDENTATION_MENU_RANK, LISTS_INDENTATION_MENU_SECTION_RANK } from '@atlaskit/editor-common/toolbar';
import { BulletedListMenuItem } from './toolbar-components/BulletedListMenuItem';
import { IndentMenuItem } from './toolbar-components/IndentMenuItem';
import { ListsIndentationHeroButton } from './toolbar-components/ListsIndentationHeroButton';
import { ListsIndentationMenu } from './toolbar-components/ListsIndentationMenu';
import { NumberedListMenuItem } from './toolbar-components/NumberedListMenuItem';
import { OutdentMenuItem } from './toolbar-components/OutdentMenuItem';
export var getToolbarComponents = function getToolbarComponents(_ref) {
  var api = _ref.api,
    showIndentationButtons = _ref.showIndentationButtons,
    allowHeadingAndParagraphIndentation = _ref.allowHeadingAndParagraphIndentation;
  return [{
    type: LISTS_INDENTATION_GROUP.type,
    key: LISTS_INDENTATION_GROUP.key,
    parents: [{
      type: TEXT_SECTION.type,
      key: TEXT_SECTION.key,
      rank: TEXT_SECTION_RANK[LISTS_INDENTATION_GROUP.key]
    }]
  }, {
    type: LISTS_INDENTATION_HERO_BUTTON.type,
    key: LISTS_INDENTATION_HERO_BUTTON.key,
    parents: [{
      type: LISTS_INDENTATION_GROUP.type,
      key: LISTS_INDENTATION_GROUP.key,
      rank: LISTS_INDENTATION_GROUP_RANK[LISTS_INDENTATION_HERO_BUTTON.key]
    }],
    component: function component(_ref2) {
      var parents = _ref2.parents;
      return /*#__PURE__*/React.createElement(ListsIndentationHeroButton, {
        api: api,
        parents: parents
      });
    }
  }, {
    type: LISTS_INDENTATION_MENU.type,
    key: LISTS_INDENTATION_MENU.key,
    parents: [{
      type: LISTS_INDENTATION_GROUP.type,
      key: LISTS_INDENTATION_GROUP.key,
      rank: LISTS_INDENTATION_GROUP_RANK[LISTS_INDENTATION_MENU.key]
    }],
    component: function component(_ref3) {
      var children = _ref3.children;
      return /*#__PURE__*/React.createElement(ListsIndentationMenu, {
        api: api,
        allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation
      }, children);
    }
  }, {
    type: LISTS_INDENTATION_MENU_SECTION.type,
    key: LISTS_INDENTATION_MENU_SECTION.key,
    parents: [{
      type: LISTS_INDENTATION_MENU.type,
      key: LISTS_INDENTATION_MENU.key,
      rank: LISTS_INDENTATION_MENU_RANK[LISTS_INDENTATION_MENU_SECTION.key]
    }]
  }, {
    type: BULLETED_LIST_MENU_ITEM.type,
    key: BULLETED_LIST_MENU_ITEM.key,
    parents: [{
      type: LISTS_INDENTATION_MENU_SECTION.type,
      key: LISTS_INDENTATION_MENU_SECTION.key,
      rank: LISTS_INDENTATION_MENU_SECTION_RANK[BULLETED_LIST_MENU_ITEM.key]
    }],
    component: function component(_ref4) {
      var parents = _ref4.parents;
      return /*#__PURE__*/React.createElement(BulletedListMenuItem, {
        api: api,
        parents: parents
      });
    }
  }, {
    type: NUMBERED_LIST_MENU_ITEM.type,
    key: NUMBERED_LIST_MENU_ITEM.key,
    parents: [{
      type: LISTS_INDENTATION_MENU_SECTION.type,
      key: LISTS_INDENTATION_MENU_SECTION.key,
      rank: LISTS_INDENTATION_MENU_SECTION_RANK[NUMBERED_LIST_MENU_ITEM.key]
    }],
    component: function component(_ref5) {
      var parents = _ref5.parents;
      return /*#__PURE__*/React.createElement(NumberedListMenuItem, {
        api: api,
        parents: parents
      });
    }
  }, {
    type: OUTDENT_MENU_ITEM.type,
    key: OUTDENT_MENU_ITEM.key,
    parents: [{
      type: LISTS_INDENTATION_MENU_SECTION.type,
      key: LISTS_INDENTATION_MENU_SECTION.key,
      rank: LISTS_INDENTATION_MENU_SECTION_RANK[OUTDENT_MENU_ITEM.key]
    }],
    component: function component(_ref6) {
      var parents = _ref6.parents;
      return /*#__PURE__*/React.createElement(OutdentMenuItem, {
        api: api,
        allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
        showIndentationButtons: showIndentationButtons,
        parents: parents
      });
    }
  }, {
    type: INDENT_MENU_ITEM.type,
    key: INDENT_MENU_ITEM.key,
    parents: [{
      type: LISTS_INDENTATION_MENU_SECTION.type,
      key: LISTS_INDENTATION_MENU_SECTION.key,
      rank: LISTS_INDENTATION_MENU_SECTION_RANK[INDENT_MENU_ITEM.key]
    }],
    component: function component(_ref7) {
      var parents = _ref7.parents;
      return /*#__PURE__*/React.createElement(IndentMenuItem, {
        api: api,
        allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
        showIndentationButtons: showIndentationButtons,
        parents: parents
      });
    }
  }];
};